import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.VITE_PUBLIC_I18N_DEBUG_MODE,
    returnNull: false,
    fallbackLng: "ar",
    supportedLngs: ["en", "ar"],
    ns: ["common", "home", "links", "notFound", "sections", "settings"],
    defaultNS: "common",
    keySeparator: ".",
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["path", "localStorage", "htmlTag", "subdomain", "navigator"],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
